var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "1200px", persistent: "" },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text" },
                [
                  _c("v-icon", { attrs: { left: "", color: "white" } }, [
                    _vm._v("mdi-file-edit-outline")
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.aguardandoReprocessamento
                          ? "Editar e Reprocessar Retorno"
                          : "Editar Falha de Retorno"
                      ) +
                      " "
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.fecharModal }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pa-6" },
                [
                  _c("Loading", {
                    attrs: { active: _vm.loading, "is-full-page": false }
                  }),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "mb-4", attrs: { outlined: "" } },
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "subtitle-1 primary--text" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", color: "primary" } },
                                    [_vm._v("mdi-file-document")]
                                  ),
                                  _vm._v(" INFORMAÇÕES DO TÍTULO ")
                                ],
                                1
                              ),
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "3" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "editable-field",
                                            attrs: {
                                              label: "Código do Status",
                                              outlined: "",
                                              dense: ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao
                                                  .cd_status_retorno,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "cd_status_retorno",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.cd_status_retorno\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "3" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "readonly-field",
                                            attrs: {
                                              label: "ID",
                                              outlined: "",
                                              dense: "",
                                              readonly: "",
                                              disabled: ""
                                            },
                                            model: {
                                              value: _vm.dadosEdicao.id_titulo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "id_titulo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "dadosEdicao.id_titulo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "readonly-field",
                                            attrs: {
                                              label: "Nosso Número",
                                              outlined: "",
                                              dense: "",
                                              readonly: "",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao.nosso_numero,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "nosso_numero",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.nosso_numero\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "mb-4", attrs: { outlined: "" } },
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "subtitle-1 warning--text" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", color: "warning" } },
                                    [_vm._v("mdi-alert-circle")]
                                  ),
                                  _vm._v(" CÓDIGO DE IRREGULARIDADE ")
                                ],
                                1
                              ),
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-textarea", {
                                            staticClass: "editable-field",
                                            attrs: {
                                              label: "Pendência",
                                              outlined: "",
                                              rows: "3"
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao
                                                  .problema_pendente,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "problema_pendente",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.problema_pendente\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-textarea", {
                                            staticClass: "editable-field",
                                            attrs: {
                                              label: "Informação Adicional",
                                              outlined: "",
                                              rows: "2"
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao.info_adicional,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "info_adicional",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.info_adicional\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "mb-4", attrs: { outlined: "" } },
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "subtitle-1 orange--text" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", color: "orange" } },
                                    [_vm._v("mdi-file-document-outline")]
                                  ),
                                  _vm._v(" ARQUIVO DE RETORNO ")
                                ],
                                1
                              ),
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "readonly-field",
                                            attrs: {
                                              label: "Protocolo Recebido",
                                              outlined: "",
                                              dense: "",
                                              readonly: "",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao
                                                  .protocolo_recebido,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "protocolo_recebido",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.protocolo_recebido\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "readonly-field",
                                            attrs: {
                                              label: "Cartório Recebido",
                                              outlined: "",
                                              dense: "",
                                              readonly: "",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao
                                                  .cartorio_recebido,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "cartorio_recebido",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.cartorio_recebido\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "readonly-field",
                                            attrs: {
                                              label: "Data do Apontamento",
                                              outlined: "",
                                              dense: "",
                                              readonly: "",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao.dt_apontamento,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "dt_apontamento",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.dt_apontamento\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "readonly-field",
                                            attrs: {
                                              label:
                                                "Código do Status (Retorno)",
                                              outlined: "",
                                              dense: "",
                                              readonly: "",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao
                                                  .tp_ocorrencia_cartorio,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "tp_ocorrencia_cartorio",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.tp_ocorrencia_cartorio\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "mb-4", attrs: { outlined: "" } },
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "subtitle-1 success--text" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", color: "success" } },
                                    [_vm._v("mdi-map-marker")]
                                  ),
                                  _vm._v(" APONTAMENTO ")
                                ],
                                1
                              ),
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6", md: "3" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "editable-field",
                                            attrs: {
                                              label: "Protocolo do Cartório",
                                              outlined: "",
                                              dense: ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao
                                                  .protocolo_cartorio,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "protocolo_cartorio",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.protocolo_cartorio\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "6", md: "3" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "editable-field",
                                            attrs: {
                                              label: "Protocolo do Cartório",
                                              outlined: "",
                                              dense: ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao.cartorio_titulo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "cartorio_titulo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.cartorio_titulo\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "readonly-field",
                                            attrs: {
                                              label: "Cartório",
                                              outlined: "",
                                              dense: "",
                                              disabled: ""
                                            },
                                            model: {
                                              value: _vm.dadosEdicao.cartorio,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "cartorio",
                                                  $$v
                                                )
                                              },
                                              expression: "dadosEdicao.cartorio"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "readonly-field",
                                            attrs: {
                                              label: "Endereço do Cartório",
                                              outlined: "",
                                              dense: "",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao
                                                  .endereco_cartorio,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "endereco_cartorio",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.endereco_cartorio\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "4" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "editable-field",
                                            attrs: {
                                              label: "Data do Apontamento",
                                              outlined: "",
                                              dense: "",
                                              type: "date"
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao
                                                  .titulo_dt_protocolo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "titulo_dt_protocolo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.titulo_dt_protocolo\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "4" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "readonly-field",
                                            attrs: {
                                              label: "Município do Apontamento",
                                              outlined: "",
                                              dense: "",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao
                                                  .municipio_apontamento,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "municipio_apontamento",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.municipio_apontamento\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "4" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "readonly-field",
                                            attrs: {
                                              label: "E-mail do Cartório",
                                              outlined: "",
                                              dense: "",
                                              type: "email",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao.email_cartorio,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "email_cartorio",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.email_cartorio\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "6" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "readonly-field",
                                            attrs: {
                                              label: "Telefone do Cartório",
                                              outlined: "",
                                              dense: "",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao
                                                  .telefone_cartorio,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "telefone_cartorio",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.telefone_cartorio\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { staticClass: "mb-4", attrs: { outlined: "" } },
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "subtitle-1 info--text" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", color: "info" } },
                                    [_vm._v("mdi-account-tie")]
                                  ),
                                  _vm._v(" APRESENTANTE ")
                                ],
                                1
                              ),
                              _c(
                                "v-card-text",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "8" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "readonly-field",
                                            attrs: {
                                              label: "Razão Social",
                                              outlined: "",
                                              dense: "",
                                              readonly: "",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.detalhesCompletos
                                                  .razao_social_apresentante,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.detalhesCompletos,
                                                  "razao_social_apresentante",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                detalhesCompletos.razao_social_apresentante\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        { attrs: { cols: "12", md: "4" } },
                                        [
                                          _c("v-text-field", {
                                            staticClass: "readonly-field",
                                            attrs: {
                                              label: "Código",
                                              outlined: "",
                                              dense: "",
                                              readonly: "",
                                              disabled: ""
                                            },
                                            model: {
                                              value:
                                                _vm.dadosEdicao.cd_apresentante,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.dadosEdicao,
                                                  "cd_apresentante",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "\n                                                dadosEdicao.cd_apresentante\n                                            "
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card",
                            { attrs: { outlined: "" } },
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "subtitle-1 purple--text" },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { left: "", color: "purple" } },
                                    [_vm._v("mdi-history")]
                                  ),
                                  _vm._v(" HISTÓRICO DE STATUS "),
                                  _c("v-spacer"),
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        color: "success",
                                        small: "",
                                        disabled: _vm.loadingHistorico
                                      },
                                      on: {
                                        click: _vm.abrirFormularioNovoHistorico
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { small: "", left: "" } },
                                        [_vm._v("mdi-plus")]
                                      ),
                                      _vm._v(" Adicionar ")
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        icon: "",
                                        small: "",
                                        loading: _vm.loadingHistorico
                                      },
                                      on: { click: _vm.recarregarHistorico }
                                    },
                                    [_c("v-icon", [_vm._v("mdi-refresh")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-card-text",
                                [
                                  _c("v-data-table", {
                                    staticClass: "elevation-0",
                                    attrs: {
                                      headers: _vm.headersHistorico,
                                      items: _vm.historicoStatus,
                                      loading: _vm.loadingHistorico,
                                      "hide-default-footer": "",
                                      "items-per-page": -1
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: `item.data`,
                                          fn: function({ item }) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatarDataHoraDB(
                                                      item.data
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: `item.status`,
                                          fn: function({ item }) {
                                            return [
                                              _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    color: _vm.getStatusColor(
                                                      item.status
                                                    ),
                                                    "text-color": "white",
                                                    small: ""
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.status) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: `item.acoes`,
                                          fn: function({ item }) {
                                            return [
                                              _c(
                                                "v-tooltip",
                                                {
                                                  attrs: { top: "" },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "activator",
                                                        fn: function({
                                                          on,
                                                          attrs
                                                        }) {
                                                          return [
                                                            _c(
                                                              "v-btn",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    attrs: {
                                                                      icon: "",
                                                                      small: "",
                                                                      color:
                                                                        "error",
                                                                      disabled:
                                                                        _vm.loadingDeleteHistorico
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.abrirConfirmacaoDeleteHistorico(
                                                                          item
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  "v-btn",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                on
                                                              ),
                                                              [
                                                                _c("v-icon", [
                                                                  _vm._v(
                                                                    "mdi-trash-can-outline"
                                                                  )
                                                                ])
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v("Excluir histórico")
                                                  ])
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _vm.historicoStatus.length === 0 &&
                                  !_vm.loadingHistorico
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-center grey--text pa-4"
                                        },
                                        [
                                          _vm._v(
                                            " Nenhum histórico de status encontrado "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "pa-6" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        loading: _vm.loading,
                        disabled: _vm.loading
                      },
                      on: { click: _vm.reprocessarRetorno }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-refresh")
                      ]),
                      _vm._v(" Reprocessar retorno ")
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "warning",
                        loading: _vm.loading,
                        disabled: _vm.loading
                      },
                      on: { click: _vm.ignorarRetorno }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-eye-off")
                      ]),
                      _vm._v(" Ignorar Retorno ")
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey", text: "", disabled: _vm.loading },
                      on: { click: _vm.fecharModal }
                    },
                    [_vm._v(" Fechar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", persistent: "" },
          model: {
            value: _vm.dialogNovoHistorico,
            callback: function($$v) {
              _vm.dialogNovoHistorico = $$v
            },
            expression: "dialogNovoHistorico"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text" },
                [
                  _c("v-icon", { attrs: { left: "", color: "white" } }, [
                    _vm._v("mdi-plus-circle")
                  ]),
                  _vm._v(" Adicionar Novo Histórico "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.fecharFormularioHistorico }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pa-6" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "formHistorico",
                      model: {
                        value: _vm.formHistoricoValido,
                        callback: function($$v) {
                          _vm.formHistoricoValido = $$v
                        },
                        expression: "formHistoricoValido"
                      }
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Status *",
                                  outlined: "",
                                  dense: "",
                                  rules: [v => !!v || "Status é obrigatório"],
                                  required: ""
                                },
                                model: {
                                  value: _vm.novoHistorico.status,
                                  callback: function($$v) {
                                    _vm.$set(_vm.novoHistorico, "status", $$v)
                                  },
                                  expression: "novoHistorico.status"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Data/Hora *",
                                  outlined: "",
                                  dense: "",
                                  type: "datetime-local",
                                  rules: [
                                    v => !!v || "Data/Hora é obrigatória"
                                  ],
                                  required: ""
                                },
                                model: {
                                  value: _vm.novoHistorico.data,
                                  callback: function($$v) {
                                    _vm.$set(_vm.novoHistorico, "data", $$v)
                                  },
                                  expression: "novoHistorico.data"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "pa-6" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        loading: _vm.loadingSalvarHistorico,
                        disabled:
                          !_vm.formHistoricoValido || _vm.loadingSalvarHistorico
                      },
                      on: { click: _vm.salvarNovoHistorico }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-content-save")
                      ]),
                      _vm._v(" Salvar ")
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey",
                        text: "",
                        disabled: _vm.loadingSalvarHistorico
                      },
                      on: { click: _vm.fecharFormularioHistorico }
                    },
                    [_vm._v(" Cancelar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "550" },
          model: {
            value: _vm.dialogConfirmDeleteHistorico,
            callback: function($$v) {
              _vm.dialogConfirmDeleteHistorico = $$v
            },
            expression: "dialogConfirmDeleteHistorico"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { "max-width": "550" } },
            [
              _c("v-card-title", { staticClass: "headline primary--text" }, [
                _vm._v(" Confirmação ")
              ]),
              _c("v-card-text", [
                _vm._v(" Deseja realmente excluir o histórico? ")
              ]),
              _vm.historicoParaDeletar
                ? _c("v-card-text", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatarDataHora(_vm.historicoParaDeletar.data)
                        ) +
                        ": " +
                        _vm._s(_vm.historicoParaDeletar.observacao) +
                        " "
                    )
                  ])
                : _vm._e(),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { disabled: _vm.loadingDeleteHistorico },
                      on: { click: _vm.fecharConfirmacaoDeleteHistorico }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: _vm.loadingDeleteHistorico,
                        color: "error"
                      },
                      on: { click: _vm.confirmarDeleteHistorico }
                    },
                    [_vm._v(" Confirmar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }